import Lenis from "@studio-freight/lenis";
import { ReactNode, createContext, useContext, useEffect, useMemo, useRef } from "react";

type SmoothScrollContextValue = {
  lenisRef: React.MutableRefObject<Lenis | null>;
};

const SmoothScrollContext = createContext<SmoothScrollContextValue | null>(null);

export function SmoothScrollProvider({ children }: { children: ReactNode }) {
  const lenisRef = useRef<Lenis | null>(null);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const lenis = new Lenis({
      smoothWheel: true,
      smoothTouch: true, // Disable smooth touch for native feel on mobile
      touchMultiplier: 1.0,
      // Lower lerp for a bit more immediate feel on mobile
      lerp: 0.12,
    } as any);
    lenisRef.current = lenis;

    const raf = (time: number) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);

    return () => {
      if (rafRef.current != null) cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const value = useMemo(() => ({ lenisRef }), []);

  return <SmoothScrollContext.Provider value={value}>{children}</SmoothScrollContext.Provider>;
}

export function useLenis() {
  const ctx = useContext(SmoothScrollContext);
  if (!ctx) return null;
  return ctx.lenisRef.current;
}


